import React, { Component } from 'react'
import payment from '../style/payment.module.css'

import Modal from './sub/modal'
class PaymentFeedback extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openModal: false
    }
  }

  render() {
    return (
      <React.Fragment>
          <div className={payment.payment_container}>
            <button
              className={payment.close_modal}
              onClick={() => {
                this.setState({
                  openModal: false
                })
              }}
            >
              &times;
            </button>
            <div className={payment.modal_container}>
              <div className={payment.image_container}>
                <svg
                  width='196'
                  height='138'
                  viewBox='0 0 196 138'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g filter='url(#filter0_f)'>
                    <rect
                      x='8'
                      y='8'
                      width='180'
                      height='118'
                      rx='17'
                      fill='#444849'
                      fillOpacity='0.08'
                    />
                  </g>
                  <rect
                    x='15'
                    y='14'
                    width='167'
                    height='106'
                    rx='14'
                    fill='white'
                  />
                  <path
                    d='M158 29C155.348 29 152.804 30.0536 150.929 31.9289C149.054 33.8043 148 36.3478 148 39C148 41.6522 149.054 44.1957 150.929 46.0711C152.804 47.9464 155.348 49 158 49C160.652 49 163.196 47.9464 165.071 46.0711C166.946 44.1957 168 41.6522 168 39C168 36.3478 166.946 33.8043 165.071 31.9289C163.196 30.0536 160.652 29 158 29Z'
                    fill='#FFC107'
                  />
                  <path
                    d='M158 29C155.348 29 152.804 30.0536 150.929 31.9289C149.054 33.8043 148 36.3478 148 39C148 41.6522 149.054 44.1957 150.929 46.0711C152.804 47.9464 155.348 49 158 49C160.652 49 163.196 47.9464 165.071 46.0711C166.946 44.1957 168 41.6522 168 39C168 36.3478 166.946 33.8043 165.071 31.9289C163.196 30.0536 160.652 29 158 29Z'
                    fill='#FFC107'
                  />
                  <path
                    d='M150.014 45C149.55 44.383 149.151 43.716 148.838 43H154.163C154.441 42.364 154.659 41.696 154.8 41H148.202C148.07 40.354 148 39.686 148 39H155C155 38.314 154.93 37.646 154.799 37H148.201C148.343 36.304 148.56 35.636 148.838 35H154.163C153.85 34.284 153.452 33.617 152.987 33H150.014C150.451 32.42 150.944 31.878 151.495 31.405C149.747 29.909 147.481 29 145 29C139.477 29 135 33.477 135 39C135 44.523 139.477 49 145 49C148.269 49 151.162 47.425 152.986 45H150.014Z'
                    fill='#FF3D00'
                  />
                  <path
                    d='M150.014 45C149.55 44.383 149.151 43.716 148.838 43H154.163C154.441 42.364 154.659 41.696 154.8 41H148.202C148.07 40.354 148 39.686 148 39H155C155 38.314 154.93 37.646 154.799 37H148.201C148.343 36.304 148.56 35.636 148.838 35H154.163C153.85 34.284 153.452 33.617 152.987 33H150.014C150.451 32.42 150.944 31.878 151.495 31.405C149.747 29.909 147.481 29 145 29C139.477 29 135 33.477 135 39C135 44.523 139.477 49 145 49C148.269 49 151.162 47.425 152.986 45H150.014Z'
                    fill='#FF3D00'
                  />
                  <rect
                    x='26'
                    y='86'
                    width='57'
                    height='6'
                    rx='3'
                    fill='#EEEEEE'
                  />
                  <rect
                    x='26'
                    y='97'
                    width='139'
                    height='6'
                    rx='3'
                    fill='#EEEEEE'
                  />
                  <rect
                    x='89'
                    y='86'
                    width='24'
                    height='6'
                    rx='3'
                    fill='#EEEEEE'
                  />
                  <path
                    d='M28.259 42.108C27.647 42.108 27.155 41.937 26.783 41.595C26.417 41.247 26.234 40.755 26.234 40.119H27.386C27.392 40.413 27.461 40.647 27.593 40.821C27.725 40.995 27.938 41.082 28.232 41.082C28.508 41.082 28.709 41.001 28.835 40.839C28.961 40.671 29.024 40.452 29.024 40.182V35.7H30.176V40.182C30.176 40.8 30.002 41.277 29.654 41.613C29.312 41.943 28.847 42.108 28.259 42.108ZM30.7246 42L33.0286 35.7H34.3246L36.6286 42H35.4046L34.9006 40.542H32.4436L31.9306 42H30.7246ZM32.7586 39.642H34.5856L33.6676 37.023L32.7586 39.642ZM37.4401 42V35.7H38.5921L41.5531 40.137V35.7H42.7051V42H41.5531L38.5921 37.572V42H37.4401ZM43.9265 42V35.7H48.0395V36.627H45.0785V38.355H47.7695V39.255H45.0785V41.073H48.0395V42H43.9265ZM51.2741 42V35.7H53.4251C54.1631 35.7 54.7691 35.832 55.2431 36.096C55.7231 36.354 56.0771 36.72 56.3051 37.194C56.5391 37.662 56.6561 38.214 56.6561 38.85C56.6561 39.486 56.5391 40.041 56.3051 40.515C56.0771 40.983 55.7231 41.349 55.2431 41.613C54.7691 41.871 54.1631 42 53.4251 42H51.2741ZM52.4261 41.01H53.3711C53.8991 41.01 54.3161 40.926 54.6221 40.758C54.9281 40.584 55.1471 40.338 55.2791 40.02C55.4111 39.696 55.4771 39.306 55.4771 38.85C55.4771 38.4 55.4111 38.013 55.2791 37.689C55.1471 37.365 54.9281 37.116 54.6221 36.942C54.3161 36.768 53.8991 36.681 53.3711 36.681H52.4261V41.01ZM60.6245 42.108C59.9945 42.108 59.4425 41.97 58.9685 41.694C58.5005 41.418 58.1315 41.037 57.8615 40.551C57.5975 40.059 57.4655 39.492 57.4655 38.85C57.4655 38.208 57.5975 37.644 57.8615 37.158C58.1315 36.666 58.5005 36.282 58.9685 36.006C59.4425 35.73 59.9945 35.592 60.6245 35.592C61.2485 35.592 61.7975 35.73 62.2715 36.006C62.7455 36.282 63.1145 36.666 63.3785 37.158C63.6425 37.644 63.7745 38.208 63.7745 38.85C63.7745 39.492 63.6425 40.059 63.3785 40.551C63.1145 41.037 62.7455 41.418 62.2715 41.694C61.7975 41.97 61.2485 42.108 60.6245 42.108ZM60.6245 41.073C61.2245 41.073 61.7015 40.875 62.0555 40.479C62.4155 40.083 62.5955 39.54 62.5955 38.85C62.5955 38.16 62.4155 37.617 62.0555 37.221C61.7015 36.825 61.2245 36.627 60.6245 36.627C60.0245 36.627 59.5445 36.825 59.1845 37.221C58.8245 37.617 58.6445 38.16 58.6445 38.85C58.6445 39.54 58.8245 40.083 59.1845 40.479C59.5445 40.875 60.0245 41.073 60.6245 41.073ZM64.7917 42V35.7H68.9047V36.627H65.9437V38.355H68.6347V39.255H65.9437V41.073H68.9047V42H64.7917Z'
                    fill='#8F7C7C'
                  />
                  <circle cx='165' cy='112' r='26' fill='#A7E791' />
                  <path
                    d='M154 112.5L159.5 117.5L176 107'
                    stroke='white'
                    strokeWidth='5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <defs>
                    <filter
                      id='filter0_f'
                      x='0'
                      y='0'
                      width='196'
                      height='134'
                      filterUnits='userSpaceOnUse'
                      colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feBlend
                        mode='normal'
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                      />
                      <feGaussianBlur
                        stdDeviation='4'
                        result='effect1_foregroundBlur'
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <h1>Payment Successful</h1>
              <p>Your payment is successful, you will be redirected in 3 seconds ....</p>
              
            </div>
          </div>
        
      </React.Fragment>
    )
  }
}

export default PaymentFeedback
